import { render, staticRenderFns } from "./WikiPageAdviceList.vue?vue&type=template&id=076ee9f0"
import script from "./WikiPageAdviceList.vue?vue&type=script&lang=ts"
export * from "./WikiPageAdviceList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports